import React, { useEffect, useState } from 'react';
import { Star, Check } from 'lucide-react';
import { publicApi } from '../lib/api';
import { packages as mockPackages } from '../mock';
import { useReservation } from '../context/ReservationContext';

const formatFCFA = (n) => new Intl.NumberFormat('fr-FR').format(n);

const renderStars = (count) => (
  <div className="flex gap-1">
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} className="w-3.5 h-3.5 fill-[#F4A340] text-[#F4A340]" />
    ))}
  </div>
);

const Packages = () => {
  const [packages, setPackages] = useState(mockPackages);
  const { openReservation } = useReservation();

  useEffect(() => {
    publicApi.getPackages()
      .then((data) => { if (data.length) setPackages(data); })
      .catch(() => {});
  }, []);

  return (
    <section id="balades" className="bg-[#FAF7F2] py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#F4A340]/10 text-[#E89534] text-xs font-semibold tracking-widest uppercase mb-4">
            Nos formules
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 leading-tight mb-6">
            Choisissez votre <span className="text-[#E89534]">expérience</span>
          </h2>
          <p className="text-slate-600 leading-relaxed text-lg">
            Nous mettons à votre disposition des bacs qui vous gardent à la fois dans le
            traditionnel et dans le moderne : un confort que nous sommes les seuls à offrir,
            sans rien perdre du savoir-faire ancestral. Guide, gilet de sauvetage et eau
            fraîche compris dans les quatre. Barque de 12 places maximum.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {packages.map((pkg) => (
            <div
              key={pkg.id}
              className={`group relative bg-white rounded-2xl overflow-hidden transition-all duration-500 hover:-translate-y-2 ${
                pkg.popular
                  ? 'border-2 border-[#F4A340] shadow-xl shadow-orange-500/10 lg:-mt-4 lg:mb-4'
                  : 'border border-slate-200 hover:border-[#F4A340]/50 hover:shadow-xl'
              }`}
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={pkg.image}
                  alt={pkg.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                {pkg.popular && (
                  <div className="absolute top-4 left-0">
                    <div className="bg-[#F4A340] text-white text-xs font-bold tracking-widest px-4 py-1.5 rounded-r-full shadow-md">
                      LE PLUS DEMANDÉ
                    </div>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>

              <div className="p-7">
                {renderStars(pkg.stars)}

                <div className="mt-3">
                  <div className="text-[#E89534] font-semibold text-sm tracking-wider">
                    {pkg.duration} · PAR PERSONNE
                  </div>
                  <h3 className="text-3xl font-bold text-slate-900 mt-1">{pkg.name}</h3>
                  <div className="uppercase text-xs tracking-widest text-slate-500 mt-1 font-medium">
                    {pkg.subtitle}
                  </div>
                </div>

                <div className="mt-6">
                  <div className="flex items-baseline gap-2">
                    <span className="text-4xl font-bold text-slate-900">
                      {typeof pkg.price === 'number' ? formatFCFA(pkg.price) : pkg.price}
                    </span>
                    <span className="text-xs text-slate-500">{pkg.priceNote}</span>
                  </div>
                  {pkg.priceExtra && (
                    <p className="mt-2 text-sm text-[#E89534] font-medium">{pkg.priceExtra}</p>
                  )}
                </div>

                <div className="h-px bg-slate-100 my-5"></div>

                <ul className="space-y-3">
                  {pkg.features.map((f, i) => (
                    <li key={i} className="flex items-start gap-3 text-sm text-slate-700">
                      <Check className="w-4 h-4 text-[#E89534] mt-0.5 flex-shrink-0" strokeWidth={3} />
                      <span className="leading-relaxed">{f}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => openReservation(pkg)}
                  className={`mt-7 w-full py-3.5 rounded-full font-semibold transition-all duration-300 ${
                    pkg.popular
                      ? 'bg-[#F4A340] hover:bg-[#E89534] text-white shadow-md hover:shadow-lg'
                      : 'bg-white border-2 border-slate-200 text-slate-900 hover:border-[#F4A340] hover:text-[#E89534]'
                  }`}
                >
                  {pkg.cta}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Packages;
